import React from 'react';

import { HStack, Tooltip } from '@chakra-ui/react';
import { themeColors } from 'themes/clients/baseTheme';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import Tag from './CustomTagChip';
import TooltipLabelList from './TooltipLabelList';

export default function CustomTagChipList({
  tags = [],
  isShowCloseButton = false,
  onTagClose = () => {},
  containerProps = {},
  tagsLimit = null,
  tagNameLengthLimit = 8,
}) {
  const displayTags = tagsLimit ? tags.slice(0, tagsLimit) : tags;
  const excessTagsLength = tags.length - displayTags.length;

  return (
    <Tooltip
      label={<TooltipLabelList labelList={tags.map((tag) => ({ displayName: tag.tagName, id: tag.uuid }))} />}
      backgroundColor={themeColors.neutral['595E6A']}
    >
      <HStack spacing="12px" padding="10px" {...containerProps} id="tag-container">
        {displayTags.map((tag) => (
          <Tag
            tag={tag}
            key={tag.uuid}
            isShowCloseButton={isShowCloseButton && !tag?.isDisabled}
            onTagClose={() => onTagClose(tag)}
            tagNameLengthLimit={tagNameLengthLimit}
          />
        ))}
        {excessTagsLength > 0 && <TextBodyMedium>+{excessTagsLength}</TextBodyMedium>}
      </HStack>
    </Tooltip>
  );
}
